import React, {useEffect, useState} from 'react';
import axios from "../../../helpers/axios";
import BlockUi from "@availity/block-ui";
import {Portlet, PortletBody, PortletHeader} from "../../../components/Portlet";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute} from "../../routesConstants";
import moment from "moment";

const IWayUpcomingOrders = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState()

  useEffect(() => {
    axios.post('/api/dashboard/iWayUpcomingOrders')
      .then(({data})=>{
        setData(data.orders)
      }).finally(()=>{
      setLoading(false)
    })
  }, []);
  return (
    <BlockUi blocking={loading}>
      <Portlet>
        <PortletHeader title={'iWai в ближайшие 36 часов'}/>
        {data && <PortletBody className={'pt-3'}>
          {data.length >0 ?
            <>
            {data.map((order,i)=>{
              const utsTime = moment(order.utcTime)
              return <div key={i}>
                {order.buyer ? order.buyer : 'Нет в базе'} <span style={{color:'rgb(204,204,217)'}}> (через {utsTime.diff(moment.utc(),'hours')} ч.)</span><br/>
                Трансфер {order.serviceId ? <Link to={TouristServicesEditRoute + order.serviceId}
                                                  target={'_blank'}>{order.orderId}</Link> : order.orderId} {order.arrivalDate}<br/>
                {order.paxes.join(',')}<br/>
                {order.route.start} - {order.route.end}<br/>
                <br/>
                {order.driverData ? <>
                  {order.driverData.driver_car && <>{order.driverData.driver_car}<br/></>}
                  {order.driverData.driver_name && <>{order.driverData.driver_name}<br/></>}
                  {order.driverData.driver_phone && <>+{order.driverData.driver_phone}<br/></>}
                </> : 'Водитель не назначен'}
                {i+1!==data.length && <hr/>}
              </div>
            })}
            </>:
            'В ближайшее время нет трансферов'}
        </PortletBody>}
      </Portlet>
    </BlockUi>
  );
};

export default IWayUpcomingOrders;
